module.exports = __webpack_public_path__ + "static/media/SportsCamp2020.de75ef16.jpeg";